export default {
    fileValidateTypeLabelExpectedTypesMap: {
        'text/csv': '.csv',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel spreadsheets',
        'application/vnd.ms-excel': 'excel spreadsheets',
    },
    labelIdle: '<i class="fad fa-file-plus aristotle-font-awesome-duotone" aria-hidden="true"></i> Drop your file ' +
        'here or <span class="filepond--label-action"> upload</span> from your computer.',
    acceptedFileTypes: [
        '.csv',
        'text/csv',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
}
